import z from 'zod';
export var TimeGranularityType;
(function (TimeGranularityType) {
    TimeGranularityType["Minute"] = "minute";
    TimeGranularityType["Hour"] = "hour";
    TimeGranularityType["Day"] = "day";
    TimeGranularityType["Week"] = "week";
    TimeGranularityType["Month"] = "month";
    TimeGranularityType["Quarter"] = "quarter";
    TimeGranularityType["Year"] = "year";
})(TimeGranularityType || (TimeGranularityType = {}));
export const timeGranularity = z.object({
    type: z.nativeEnum(TimeGranularityType),
    value: z.number(),
});
